"use strict"

export function highlightTextModel(text, matchWords) {
  const spans = []
  let index = 0

  while (index < text.length) {
    let nextIndex = -1,
      nextIndexWord = ""

    for (const word of matchWords || []) {
      const possIndex = text.toLowerCase().indexOf(word.toLowerCase(), index)
      if (possIndex >= 0) {
        if (
          nextIndex < 0 ||
          possIndex < nextIndex ||
          (possIndex === nextIndex && word.length > nextIndexWord.length)
        ) {
          nextIndex = possIndex
          nextIndexWord = word
        }
      }
    }

    if (nextIndex >= 0) {
      if (nextIndex > 0) {
        spans.push({
          text: text.substring(index, nextIndex),
          highlight: false,
        })
      }
      spans.push({
        text: text.substring(nextIndex, nextIndex + nextIndexWord.length),
        highlight: true,
      })
      index = nextIndex + nextIndexWord.length
    } else if (nextIndex < 0) {
      spans.push({
        text: text.substring(index),
        highlight: false,
      })
      index = text.length
    }
  }
  return spans
}

/*
 * Alternative, "single-string" highlighting model, used for places where full-text searching isn't
 * currently used.
 */

export function highlightTextModelSimple(text, search) {
  text = text || ""
  const spans = []
  let index = 0

  while (index < text.length) {
    const nextIndex = search ? text.toLowerCase().indexOf(search.toLowerCase(), index) : -1

    if (nextIndex >= 0) {
      if (nextIndex > 0) {
        spans.push({
          text: text.substring(index, nextIndex),
          highlight: false,
        })
      }
      spans.push({
        text: text.substring(nextIndex, nextIndex + search.length),
        highlight: true,
      })
      index = nextIndex + search.length
    } else if (nextIndex < 0) {
      spans.push({
        text: text.substring(index),
        highlight: false,
      })
      index = text.length
    }
  }

  return spans
}
